import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { analyticsReducer, initialAnalyticsState } from '@context/analyticsReducer';
import { AnalyticsActionType } from 'types/analytics';

interface AnalyticsContextType {
  analyticsState: typeof initialAnalyticsState;
  dispatch: (action: AnalyticsActionType) => void;
}

interface AnalyticsProviderProps {
  children: ReactNode;
}

const AnalyticsContext = createContext<AnalyticsContextType | undefined>(undefined);

export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  const [analyticsState, dispatch] = useReducer(analyticsReducer, initialAnalyticsState);

  return (
    <AnalyticsContext.Provider value={{ analyticsState, dispatch }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalyticsContext = (): AnalyticsContextType => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalyticsContext must be used within AnalyticsProvider');
  }
  return context;
};